export const headers = [
  { label: "Date and Time", key: "tableDate" },
  { label: "Payment Reference", key: "reference" },
  { label: "Payment Description", key: "description" },
  { label: "Amount", key: "amount", formatter: (value) => parseInt(value) },
  { label: "Status", key: "status" },
];
